import { InsertDriveFileOutlined } from '@mui/icons-material';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';
import { ListRow } from './ListRow';

export type AttachmentItemProps = {
  name: string;
  description?: ReactNode;
  status?: ReactNode;
  error?: ReactNode;
  busy?: boolean;
  disabled?: boolean;
  onRemove?: () => void;
  removeLabel?: string;
  actions?: ReactNode;
};

/** 첨부 이름과 처리 상태·오류·행동을 표시합니다. 파일 저장과 접근 권한은 호출자가 정합니다. */
export function AttachmentItem({ name, description, status, error, busy = false, disabled = false, onRemove, removeLabel = '제거', actions }: AttachmentItemProps) {
  const hasContent = (value: ReactNode) => value !== undefined && value !== null && value !== '' && typeof value !== 'boolean';
  return <ListRow
    label={name} density="compact" inset="none"
    icon={busy ? <CircularProgress size={designTokens.layout.pageHeaderControlGlyphSize} aria-hidden /> : <InsertDriveFileOutlined aria-hidden fontSize="small" />}
    description={hasContent(description) || hasContent(status) || hasContent(error) ? <Stack spacing={0.5}>
      {description}
      {hasContent(status) ? <Typography component="div" variant="caption" role="status">{status}</Typography> : null}
      {hasContent(error) ? <Typography component="div" variant="caption" role="alert" sx={{ color: designTokens.color.dangerText }}>{error}</Typography> : null}
    </Stack> : undefined}
    trailing={actions || onRemove ? <>
      {actions}
      {onRemove ? <Button type="button" variant="text" size="small" aria-label={`${name} ${removeLabel}`} disabled={disabled || busy} onClick={onRemove}>{removeLabel}</Button> : null}
    </> : undefined}
  />;
}
